import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ProductToast, ProductToastTypes } from '../models/product-toast.model';

@Injectable({
  providedIn: 'root',
})
export class ProductDetailToastService {
  constructor() {}

  private toastSubject = new Subject<ProductToast>();

  getProductToasts$ = (): Observable<ProductToast> =>
    this.toastSubject.asObservable();

  clearToast = () => this.toastSubject.next(null);

  publish = (toast: ProductToast) => this.toastSubject.next(toast);

  publishSuccess = (message: string) =>
    this.publish({
      type: ProductToastTypes.success,
      message,
    });

  publishError = (message: string) =>
    this.publish({
      type: ProductToastTypes.error,
      message,
    });
}
